var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalTaskPerfomance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_17808",
    "data-name": "Group 17808",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34705",
    "data-name": "Path 34705",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34706",
    "data-name": "Path 34706",
    d: "M17,2h3a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V3A1,1,0,0,1,4,2H7V0H9V2h6V0h2Zm0,2V6H15V4H9V6H7V4H5V20H19V4ZM7,8H17v2H7Zm0,4H17v2H7Z",
    fill: "#7c0e6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTaskPerfomance);
export default __webpack_public_path__ + "static/media/total_task_perfomance.fa908e7d9aeba1fdc80a5de3037f8fa1.svg";
export { ForwardRef as ReactComponent };